import React from 'react';

export function Pong(){


    return(
        <div>
            <p>pong!</p>
        </div>
    );
}